// @core/api/endpoints/booking/create_review.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingReviewResponse,
  CreateReviewRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Create review
 * Creates a review for a completed booking or booking-aware entity. Bidirectional: customer rates provider/resource, provider optionally rates customer.
 */
export async function CreateReview(
  target_type: string,
  target_id: string,
  data: CreateReviewRequest,
  options?: RequestOptions
): Promise<BookingReviewResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking/:target_type/:target_id/reviews`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<BookingReviewResponse>(requestPath, data, requestOptions);
}
